import { render, staticRenderFns } from "./PBtn.vue?vue&type=template&id=16b1b981"
import script from "./PBtn.vue?vue&type=script&lang=js"
export * from "./PBtn.vue?vue&type=script&lang=js"
import style0 from "./PBtn.vue?vue&type=style&index=0&id=16b1b981&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports